import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
  >
    <rect x="0.318359" y="6" width="17" height="11" fill="#222A5C" />
    <path
      d="M1.91981 5L3.87383 1H13.7629L15.7169 5H1.91981Z"
      stroke="#222A5C"
      strokeWidth="2"
    />
    <path
      d="M14.2178 9.99988L9.14265 13.9468L4.0293 9.99988"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M9.14282 5.99989L9.14282 13.7759"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>,
  "Archive"
);
